require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-member-services-member-benefits.json") })
        }
      }, "path---es-member-services-member-benefits");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-member-services-member-benefits!./.cache/json/es-member-services-member-benefits.json
// module id = 2590
// module chunks = 231608221292675